import { ProfileType, TermType } from '@witkac/kartamiejska-shared';
import { RouteConfig } from 'vue-router';

import store from '@/store';

export const registerRoute: RouteConfig = {
  path: '/register',
  name: 'register',
  component: () => import(/* webpackChunkName: "Register" */ '@/views/start/Register.vue'),
  beforeEnter: (to, from, next) =>
    store.dispatch('terms/getCurrent', { profileType: ProfileType.CLIENT, type: TermType.REGISTER }).then(() => next())
};
